var _path, _path2, _path3, _rect, _rect2, _rect3;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAddProduct = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 53,
    viewBox: "0 0 67 53",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0868 47.3534C28.0868 55.2429 15.7802 54.2755 17.1965 46.0044C18.1453 40.4723 28.0868 40.2951 28.0868 47.3534Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5827 46.0044C53.999 54.2755 41.6993 55.2429 41.6924 47.3534C41.6924 40.2951 51.6271 40.4723 52.5827 46.0044Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1958 46.0048C14.6658 46.1615 12.3213 43.266 11.5307 41.1676L6.88989 8.00863C6.22987 5.95791 0.454684 8.15171 0.839696 3.90038C1.22471 -0.350944 9.24121 1.16836 11.3588 4.92915C12.1907 6.40757 12.2869 9.4053 12.4588 9.56881C12.6857 9.78002 16.2264 9.56881 17.1958 9.59607C28.5056 9.88903 39.9115 9.22135 51.2144 9.59607C56.0889 9.75958 60.4822 8.87389 60.7916 15.319C61.0047 19.7543 59.5747 35.8262 58.5434 40.1252C57.9934 42.4144 55.3533 46.2501 52.5757 46.0117C51.6269 40.4795 41.6853 40.3023 41.6853 47.3606H28.0793C28.0793 40.3023 18.1446 40.4795 17.189 46.0117L17.1958 46.0048Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.8193,
    y: 0.925781,
    width: 20,
    height: 19,
    rx: 9.5,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1445,
    y: 9.92773,
    width: 9.34938,
    height: 1.69989,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6689,
    y: 5.75195,
    width: 9.34938,
    height: 1.69989,
    transform: "rotate(90 57.6689 5.75195)",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddProduct, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/addProduct.faa03433.svg";
export { ForwardRef as ReactComponent };